import React from 'react';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_BACKGROUND_PRIMARY,
  COLOR_OVERLAY_BACKDROP_LIGHT,
  COLOR_OVERLAY_SHADOW,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_TERTIARY,
} from '../colors/colors';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${COLOR_OVERLAY_BACKDROP_LIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const ModalContainer = styled.div`
  background: ${COLOR_BACKGROUND_PRIMARY};
  border-radius: ${RADIUS.MD};
  padding: 24px;
  width: 90%;
  max-width: 360px;
  box-shadow: 0 4px 24px ${COLOR_OVERLAY_SHADOW};
`;

const Title = styled.h3`
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
`;

const Body = styled.div`
  font-size: 14px;
  color: ${COLOR_TEXT_TERTIARY};
  line-height: 1.5;
`;

export const YouModal = ({ title, children, onClose }) => {
  return (
    <Backdrop onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {title && <Title>{title}</Title>}
        <Body>{children}</Body>
      </ModalContainer>
    </Backdrop>
  );
};
